import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { withTranslation } from "../translation";
import ShopWomenAndMen from "../ShopWomenAndMen";
import NotFoundMessage from "../NotFound/NotFoundMessage";
import { getCategoryIsBrand } from "../../state/modules/category";
import { mensNewIn, womensNewIn } from "./constants";

export const CategoryOutOfStock = props => {
  const { formatLink, formatTranslation } = props;
  const isBrand = useSelector(getCategoryIsBrand);
  const { errorMessage, suggestionMessage } = isBrand
    ? {
        errorMessage: formatTranslation("plp_web_oos_brand_page"),
        suggestionMessage: formatTranslation("plp_web_brand_suggestion_message")
      }
    : {
        errorMessage: formatTranslation("plp_web_oos_category_page"),
        suggestionMessage: ""
      };

  return (
    <div>
      <NotFoundMessage
        errorMessage={errorMessage}
        suggestionMessage={suggestionMessage}
      />
      <ShopWomenAndMen
        shopWomenLink={formatLink(womensNewIn)}
        shopWomenMessage={formatTranslation("plp_web_search_shop_women")}
        shopMenLink={formatLink(mensNewIn)}
        shopMenMessage={formatTranslation("plp_web_search_shop_men")}
      />
    </div>
  );
};

CategoryOutOfStock.propTypes = {
  formatLink: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

CategoryOutOfStock.displayName = "CategoryOutOfStock";

export default withTranslation(CategoryOutOfStock);
